import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CatalogFilterCardComponent} from '@app/catalog/search/catalog-filters/catalog-filter-card/catalog-filter-card.component';
import {CatalogSearchFilterEntry, OrderedCatalogSearchFilterEntries} from '@store/catalog/catalog.types';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';

@Component({
  selector: 'px-catalog-filters',
  host: {
    class: 'flex flex-col lg:gap-y-1'
  },
  template: `
    @let firstEntry = selectors.firstPopulatedFilterFor(OrderedCatalogSearchFilterEntries) | select;
    @for (entry of OrderedCatalogSearchFilterEntries; track $index) {
      <px-catalog-filter-card [filterName]="entry.filterName" [cardTitle]="entry.cardTitle"
                              [expansionState]="entry === firstEntry ? 'expanded' : 'collapsed'"/>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CatalogFilterCardComponent, SelectPipe]
})
export class CatalogFiltersComponent {
  public readonly selectors = CatalogSelectors.List;
  public readonly OrderedCatalogSearchFilterEntries: CatalogSearchFilterEntry[] = OrderedCatalogSearchFilterEntries;
}
